// extracted by mini-css-extract-plugin
export default {"container":"tenantJobFormRulesList_container__rigGs"};